module.exports = __webpack_public_path__ + "img/user.2fd3c988.png";